import { render, staticRenderFns } from "./TableSpecialCareList.vue?vue&type=template&id=2312fe28&scoped=true"
import script from "./TableSpecialCareList.vue?vue&type=script&lang=js"
export * from "./TableSpecialCareList.vue?vue&type=script&lang=js"
import style0 from "./TableSpecialCareList.vue?vue&type=style&index=0&id=2312fe28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312fe28",
  null
  
)

export default component.exports